import jwtDecode from "jwt-decode";

export const getICTTenantFromToken = (token: string) => {
  const decodedToken = jwtDecode(token) as any;
  return decodedToken?.tenant;
};
